<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{
              name: 'DashboardHome',
            }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>LINE 應用中心</b-breadcrumb-item>
            <template v-if="isTemplatePage">
              <b-breadcrumb-item :to="{
                name: 'PushMessageTemplate',
              }">
                訊息範本
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ `${isEditing ? "編輯" : isView ? "查看" : "新增"}訊息範本` }}
              </b-breadcrumb-item>
            </template>
            <template v-else>
              <b-breadcrumb-item :to="{
                name: 'PushMessage',
              }">
                群發訊息
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ `${isEditing ? "編輯" : isView ? "查看" : "新增"}訊息` }}
              </b-breadcrumb-item>
            </template>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="row mb-2 align-items-center">
        <div class="col-12 col-xl-2">
          <h4 class="font-weight-bold" v-if="isTemplatePage">
            {{ `${isEditing ? "編輯" : (isView ? "查看" : "新增")}訊息範本` }}
          </h4>
          <h4 class="font-weight-bold" v-else>
            {{ `${isEditing ? "編輯" : (isView ? "查看" : "新增")}訊息` }}
          </h4>
        </div>
        <div class="flex-fill d-flex justify-content-end">
          <StaffAddCustomer ref="staffAddCustomer" class="justify-content-end pr-3" add-button-text="測試推播"
            :disable-main-button="!saveable || isDetailCopy || isTemplateCopy" @bind="testBroadcast"
            :validate="validate">
          </StaffAddCustomer>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-2 col-form-label">標題</label>
        <div class="col-sm-10">
          <b-form-input type="text" class="form-control" placeholder="訊息標題將顯示於推播通知及聊天一覽中"
            :state="v$.title.$error ? false : null" maxlength="100" required v-model="title" :disabled="isView" />
          <b-form-invalid-feedback :state="!v$.title.$error">
            此欄位為必填
          </b-form-invalid-feedback>
        </div>
      </div>
      <template v-if="!isTemplatePage">
        <div class="form-group form-row">
          <label class="col-sm-2 col-form-label">發送時間：</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-6">
                <datepicker placeholder="日期" v-model="publish_at.date" bootstrap-styling format="yyyy-MM-dd"
                  :language="zh" :input-class="v$.publish_at.date.$error ? 'is-invalid' : ''"
                  :disabledDates="{ to: new Date(Date.now() - 8640000) }" :disabled="isView"></datepicker>
                <b-form-invalid-feedback :state="!v$.publish_at.date.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </div>
              <div class="col-sm-6 timepicker">
                <vue-timepicker :input-class="`${v$.publish_at.time.HH.$error || v$.publish_at.time.mm.$error
                  ? 'is-invalid'
                  : ''
                  } form-control`" :hour-label="'時間'" :minute-label="'分鐘'" v-model="publish_at.time" hide-clear-button
                  placeholder="選擇時間" :disabled="isView">
                </vue-timepicker>
                <b-form-invalid-feedback :state="!v$.publish_at.time.HH.$error && !v$.publish_at.time.mm.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
                <b-form-invalid-feedback :state="!v$.publish_at.$error">
                  發送時間不得小於目前時間
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-2 col-form-label">推播類型：</label>
          <div class="col-sm-10">
            <div class="row">
              <b-select class="col-4" v-model="pushType" :options="pushTypeOptions"
                :disabled="isView || !$permissions.has($permissions.consts.OA_PUSH_NARROWCAST)"></b-select>
            </div>
          </div>
        </div>
        <div class="form-group form-row" v-if="!isTemplatePage">
          <label class="col-sm-2 col-form-label">分店：</label>
          <div class="col-sm-10">
            <div class="row">
              <b-select class="col-4" v-model="branchId" :options="branchOptions" :disabled="branchSelectIsDisabled"
                @change="handleBranchIsSelected">
              </b-select>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-2 col-form-label">受眾群組：</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-4 px-0" style="position: relative;">
                <b-select v-model="audienceId" :options="audiences" :state="v$.audienceId.$error ? false : null"
                  :disabled="typeof $route.query.audience_id !== 'undefined' || isView"> </b-select>
                <div class="spinner-wrapper" v-if="isFetchingAudiences">
                  <b-spinner style="border-width: 1px" small />
                </div>
                <b-form-invalid-feedback :state="!v$.audienceId.$error">
                  此欄位為必填
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="rounded rounded-2xl border border-secondary p-3 mb-3">
        <b-card v-for="(i, idx) in messages" :key="idx" class="shadow-none mb-3" header-bg-variant="light"
          header-class="p-3">
          <template #header>
            <div class="d-flex justify-content-between align-content-center">
              <b-form-radio-group v-model="i.content.type" :options="messageTypeOptions"
                @change="messageTypeChange(i, idx)" :disabled="isView"></b-form-radio-group>

              <div>
                <b-button variant="link" class="text-dark" @click="swapMessage(idx, -1)" :disabled="idx == 0"><i
                    class="fa fa-angle-up" aria-hidden="true"></i></b-button>
                <b-button variant="link" class="text-dark" :disabled="idx == messages.length - 1"
                  @click="swapMessage(idx, 1)"><i class="fa fa-angle-down" aria-hidden="true"></i></b-button>
                <b-button v-if="idx > 0" variant="link" class="text-dark" @click="removeMessage(idx)"><i
                    class="fa fa-times" aria-hidden="true"></i></b-button>
              </div>
            </div>
          </template>

          <template v-if="i.content.type == 'text'">
            <b-form-textarea :disabled="isView" v-model="i.content.text" placeholder="請輸入訊息" rows="6"></b-form-textarea>
            <b-form-invalid-feedback :state="!v$.$dirty || !messagesValidation[idx].error"> 此欄位為必填
            </b-form-invalid-feedback>
          </template>

          <template v-else-if="i.content.type == 'image'">
            <div class="message-image">
              <div v-if="i.content.previewImageUrl" class="image">
                <b-img thumbnail fluid :src="i.content.previewImageUrl"></b-img>
                <b-button v-if="!isView" variant="danger" pill class="remove" @click="
                  () => {
                    i.content.originalContentUrl = null;
                    i.content.previewImageUrl = null;
                    $forceUpdate();
                  }
                "><i class="fa fa-times m-0" aria-hidden="true"></i></b-button>
              </div>
              <ImageSelector v-else @input="(image) => { uploadImage(image, i.content) }">
                <template #trigger="{ openFileSelector }">
                  <b-button class="border p-3 text-center bg-white d-block w-100" @click="openFileSelector"
                    :disabled="isView">
                    <div class="text-primary mb-2">上傳照片</div>
                    <i class="fa fa-2x fa-picture-o text-secondary" aria-hidden="true"></i>
                    <div class="mt-2" style="color: #7f8182;">圖片尺寸建議：1040px x 1040px</div>
                  </b-button>
                </template>
              </ImageSelector>
              <b-form-invalid-feedback :state="!v$.$dirty || !messagesValidation[idx].error"> 請上傳圖片
              </b-form-invalid-feedback>
            </div>
          </template>

          <template v-else-if="
            i.content.type == 'imagemap' && i.content.actions != undefined
          ">
            <div class="d-flex message-imagemap">
              <div class="image mr-4">
                <div class="template border border-primary">
                  <b-img fluid :src="i.content.baseUrl"></b-img>
                  <button class="action border border-primary d-flex justify-content-center align-items-center"
                    v-for="(a, adx) in i.content.actions" :key="adx" :style="{
                      left: `${(a.area.x / i.content.baseSize.width) * 100}%`,
                      top: `${(a.area.y / i.content.baseSize.height) * 100}%`,
                      width: `${(a.area.width / i.content.baseSize.width) * 100
                        }%`,
                      height: `${(a.area.height / i.content.baseSize.height) * 100
                        }%`,
                    }" v-b-toggle="`accordion-${adx}`">
                    <span> {{ ["A", "B", "C", "D", "E", "F"][adx] }}</span>
                  </button>
                </div>
                <div>
                  <b-button class="mt-2" v-b-modal.modal-imagemap-template block :disabled="isView">選擇版型</b-button>
                  <ImageSelector @input="(image) => { uploadImageMap(image, i.content) }">
                    <template #trigger="{ openFileSelector }">
                      <b-button class="mt-2" block @click="openFileSelector" :disabled="isView">上傳圖片</b-button>
                      <b-form-invalid-feedback :state="!v$.$dirty || !messagesValidation?.[idx]?.error"> 請上傳圖片
                      </b-form-invalid-feedback>
                    </template>
                  </ImageSelector>
                </div>

                <b-modal id="modal-imagemap-template" title="選擇版型" class="modal-imagemap-template" centered hide-footer
                  size="xl">
                  <template #modal-title>
                    <div>選擇版型</div>
                    <div style="color: #7f8182; font-size: 1rem;">圖片尺寸建議：1040px x 1040px</div>
                  </template>

                  <div class="d-flex flex-wrap justify-center">
                    <button class="btn btn-link bg-secondary template border border-primary m-2"
                      v-for="(t, tdx) in imagemapTemplate" :key="tdx" @click="() => setImageMapTemplate(t, idx)">
                      <div class="action border border-primary" v-for="(a, adx) in t.actions" :key="adx" :style="{
                        left: `${(a.area.x / i.content.baseSize.width) * 100}%`,
                        top: `${(a.area.y / i.content.baseSize.height) * 100}%`,
                        width: `${(a.area.width / i.content.baseSize.width) * 100
                          }%`,
                        height: `${(a.area.height / i.content.baseSize.height) * 100
                          }%`,
                      }"></div>
                    </button>
                  </div>
                </b-modal>
              </div>

              <div class="flex-fill" role="tablist">
                <b-card v-for="(a, adx) in i.content.actions" :key="adx" no-body class="mb-2 shadow-none">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="`accordion-${adx}`" variant="link" class="text-left">
                      {{ ["A", "B", "C", "D", "E", "F"][adx] }}
                    </b-button>
                  </b-card-header>
                  <b-collapse :id="`accordion-${adx}`" visible accordion="accordion">
                    <b-card-body>
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-right">類型</label>
                        <div class="col-sm-10">
                          <b-select :disabled="isView">
                            <b-select-option>連結</b-select-option>
                          </b-select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="offset-sm-2 col-sm-10">
                          <input type="url" class="form-control" placeholder="輸入網址" required v-model="a.linkUri"
                            :disabled="isView" />
                          <b-form-invalid-feedback
                            :state="!v$.$dirty || !messagesValidation?.[idx]?.actions?.[adx]?.errorLinkUri">
                            請填入正確連結
                          </b-form-invalid-feedback>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-right">動作標籤</label>
                        <div class="col-sm-10">
                          <b-textarea rows="6" placeholder="輸入動作標籤的說明" v-model="a.label" :disabled="isView">
                          </b-textarea>
                          <b-form-invalid-feedback
                            :state="!v$.$dirty || !messagesValidation?.[idx]?.actions?.[adx]?.errorLabel">
                            此欄位為必填
                          </b-form-invalid-feedback>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </template>

          <template v-else-if="
            i.content.type == 'flex' && i.content.contents != undefined
          ">
            <div class="message-flex">
              <b-nav tabs content-class="mt-3">
                <b-nav-item v-for="(c, cdx) in i.content.contents.contents" :key="cdx"
                  :active="i.content.tabIndex == cdx" @click="() => setFlexTabIndex(idx, cdx)">
                  {{ (cdx + 1).toString() }}
                </b-nav-item>
              </b-nav>

              <div class="d-flex justify-content-end py-3">                
                <b-button
                  :disabled="isView || (i.content.contents.contents.length >= 10)"
                  variant="outline-dark"
                  class="px-2 mx-1"
                  @click="flexNewPage(i)"
                >
                  <i class="fa fa-file-o m-0" aria-hidden="true"></i>
                </b-button>
                <b-button
                  :disabled="isView || (i.content.tabIndex === 0)"
                  variant="outline-dark"
                  class="px-2 mx-1"
                  @click="() => setFlexTabIndex(idx, i.content.tabIndex - 1)"
                >
                  <i class="fa fa-angle-left mx-1" aria-hidden="true"></i>
                </b-button>
                <b-button
                  :disabled="isView || (i.content.tabIndex === i.content.contents.contents.length - 1)"
                  variant="outline-dark"
                  class="px-2 mx-1"
                  @click="() => setFlexTabIndex(idx, i.content.tabIndex + 1)"
                >
                  <i class="fa fa-angle-right mx-1" aria-hidden="true"></i>
                </b-button>
                <b-button
                  :disabled="isView || i.content.tabIndex === 0 && i.content.contents.contents.length === 1"
                  variant="outline-dark"
                  class="px-2 mx-1"
                  @click="
                    () => {
                      deleteFlexTab(idx, i.content.tabIndex);
                    }
                  "
                >
                  <i class="fa fa-times m-0" aria-hidden="true"></i>
                </b-button>
              </div>

              <div class="d-flex">
                <div class="image mr-4">
                  <b-carousel v-model="i.content.tabIndex" controls :interval="0" no-wrap no-animation>
                    <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                    <b-carousel-slide v-for="(c, cdx) in i.content.contents.contents" :key="cdx">
                      <template #img>
                        <b-card class="m-3 flex-button rounded-lg pb-2" no-body :style="{
                          backgroundColor: c.styles.hero.backgroundColor,
                        }">
                          <b-badge v-if="c.hero.contents[1]" class="altText" variant="primary">{{
                            c.hero.contents[1].contents[0].text
                            }}</b-badge>

                          <div class="image-frame">
                            <div :class="`frame-${c.hero.contents
                              .map((x) => x.contents)
                              .reduce((y, z) => y.concat(z), [])
                              .filter((x) => x.type == 'image').length
                              }`">
                              <div class="frame" v-for="(img, imgdx) in c.hero.contents
                                .map((x) => x.contents)
                                .reduce((y, z) => y.concat(z), [])
                                .filter((x) => x.type == 'image')" :key="imgdx">
                                <b-img v-if="img.url" :src="img.url" />
                              </div>
                            </div>
                          </div>

                          <div class="p-3 body">
                            <h4 :class="[c.body.contents[0].contents[0].size]" :style="{
                              fontWeight: c.body.contents[0].contents[0].weight,
                              textAlign: c.body.contents[0].contents[0].align,
                              color: c.body.contents[0].contents[0].color,
                            }">
                              {{
                                c.body.contents[0].contents[0].text || "頁面標題"
                              }}
                            </h4>

                            <h5 v-if="c.body.contents.length == 3 && c.body.contents[1]"
                              :class="[c.body.contents[1].contents[0].size]" :style="{
                                fontWeight: c.body.contents[1].contents[0].weight,
                                textAlign: c.body.contents[1].contents[0].align,
                                color: c.body.contents[1].contents[0].color,
                              }">
                              {{
                                c.body.contents[1].contents[0].text ||
                                "頁面副標題"
                              }}
                            </h5>
                            <p v-for="(t, tdx) in c.body.contents[c.body.contents.length - 1].contents" :key="tdx"
                              :class="[t.size, 'mb-0']">
                              {{ t.text || "文字說明" }}
                            </p>
                          </div>

                          <div class="footer p-0">
                            <div v-for="(f, fdx) in c.footer.contents.filter((x) => {
                              return x.type == 'button';
                            })" :key="fdx">
                              <b-button :href="f.action.uri" variant="link" target="_blank" block class="m-0 p-2"
                                v-if="f.action.label != ''">{{ f.action.label }}</b-button>
                            </div>
                          </div>
                        </b-card>
                      </template>
                    </b-carousel-slide>
                  </b-carousel>
                </div>

                <div class="flex-fill">
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">宣傳標語</label>
                    <div class="col-sm-10">

                      <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                          <input type="checkbox" @click="(e) => {
                            if (e.target.checked) {
                              i.content.contents.contents[i.content.tabIndex].hero.contents[1] = {
                                type: 'box',
                                layout: 'vertical',
                                contents: [
                                  {
                                    type: 'text',
                                    text: '宣傳標語',
                                    color: '#ffffff',
                                    align: 'center',
                                    size: 'xs',
                                    offsetTop: '4px',
                                  },
                                ],
                                position: 'absolute',
                                cornerRadius: '15px',
                                backgroundColor: '#ff334b',
                                height: '25px',
                                offsetTop: '10px',
                                offsetStart: '10px',
                                paddingStart: '5px',
                                paddingEnd: '5px',
                              }
                            } else { i.content.contents.contents[i.content.tabIndex].hero.contents.splice(-1) }
                            $forceUpdate();
                          }" :checked="i.content.contents.contents[i.content.tabIndex].hero.contents[1]" />
                        </b-input-group-prepend>
                        <b-input v-if="i.content.contents.contents[i.content.tabIndex].hero.contents[1]" type="text"
                          class="form-control" placeholder="請輸入宣傳標語" maxlength="12" required :disabled="isView" v-model="i.content.contents.contents[i.content.tabIndex].hero
                            .contents[1].contents[0].text
                            " />
                        <b-input v-else type="text" class="form-control" placeholder="請輸入宣傳標語" disabled />
                        <b-form-invalid-feedback v-if="i.content.contents.contents[i.content.tabIndex].hero.contents[1]"
                          :state="!v$.$dirty || !messagesValidation?.[idx]?.[i.content.tabIndex]?.errorHeroText"> 此欄位為必填
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">圖片</label>
                    <div class="col-sm-10">
                      <b-select :disabled="isView" :options="[1, 2, 3]" :value="i.content.contents.contents[
                        i.content.tabIndex
                      ].hero.contents
                        .map((x) => x.contents)
                        .reduce((y, z) => y.concat(z), [])
                        .filter((x) => x.type == 'image').length
                        " @change="flexImageChange(i, $event)"></b-select>
                      <div class="mt-2" style="color: #7f8182; font-size: 0.75rem;">* 圖片尺寸建議：1040px x 1040px</div>
                      <div style="color: #7f8182; font-size: 0.75rem;">* 圖片可選擇 1~3 張，呈現方式如預覽畫面</div>
                      <div class="d-flex align-items-center">
                        <span class="d-inline-block position-relative" v-for="(img, imgdx) in i.content.contents.contents[
                          i.content.tabIndex
                        ].hero.contents
                          .map((x) => x.contents)
                          .reduce((y, z) => y.concat(z), [])
                          .filter((x) => x.type == 'image')" :key="imgdx">
                          <b-button :disabled="isView" v-if="img.url" variant="link"
                            class="image-button mt-3 mr-3 border p-0" @click="
                              $bvModal.show(
                                `modal-flex-upload-${idx}-${i.content.tabIndex}-${imgdx}`
                              )
                              ">
                            <img :src="img.url" class="img-fluid" />
                          </b-button>
                          <ImageSelector v-else @input="(image) => { uploadFlex(image, img) }">
                            <template #trigger="{ openFileSelector }">
                              <button :disabled="isView" class="image-button mt-3 mr-3 border p-0"
                                @click="openFileSelector">
                                <span>{{ ["A", "B", "C"][imgdx] }}</span>
                              </button>
                            </template>
                          </ImageSelector>
                          <b-button v-if="!isView" variant="danger" pill class="remove"
                            @click="() => { img.url = '' }">
                            <i class="fa fa-times m-0" aria-hidden="true"></i>
                          </b-button>
                        </span>
                      </div>

                      <b-form-invalid-feedback
                          :state="!v$.$dirty || !messagesValidation?.[idx]?.[i.content.tabIndex]?.errorImageUrl">
                          請上傳圖片
                        </b-form-invalid-feedback>

                     


                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">頁面標題</label>
                    <div class="col-sm-10">
                      <b-input :disabled="isView" type="text" class="form-control" placeholder="輸入標題" maxlength="20"
                        required v-model="i.content.contents.contents[i.content.tabIndex].body
                          .contents[0].contents[0].text
                          " />
                      <b-form-invalid-feedback
                        :state="!v$.$dirty || !messagesValidation?.[idx]?.[i.content.tabIndex]?.errorBodyText">
                        此欄位為必填
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">頁面副標題</label>
                    <div class="col-sm-10">
                      <b-input :disabled="isView" type="text" class="form-control" placeholder="副標題" maxlength="20"
                        :value="i.content.contents.contents[i.content.tabIndex].body.contents.length == 3 ? i.content.contents.contents[i.content.tabIndex].body.contents[1].contents[0].text : null"
                        @input="(value) => {
                          let body = i.content.contents.contents[i.content.tabIndex].body;
                          if (body.contents.length == 3) {
                            if (value)
                              body.contents[1].contents[0].text = value
                            else
                              body.contents.splice(1, 1)
                          } else {
                            if (value)
                              body.contents.splice(1, 0, {
                                type: 'box',
                                layout: 'vertical',
                                contents: [
                                  {
                                    type: 'text',
                                    text: value,
                                    size: 'md',
                                    weight: 'bold',
                                    wrap: true,
                                  },
                                ],
                              })
                          }
                        }" />
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">
                      文字說明
                    </label>
                    <div class="col-sm-10">
                      <b-textarea :disabled="isView" v-if="
                        i.content.contents.contents[i.content.tabIndex].body
                          .contents.length > 1
                      " class="form-control" rows="5" placeholder="輸入文字說明" maxlength="60" required v-model="i.content.contents.contents[i.content.tabIndex].body
                        .contents[i.content.contents.contents[i.content.tabIndex].body
                          .contents.length - 1].contents[0].text
                        " />
                      <b-textarea v-else class="form-control" rows="5" placeholder="輸入文字說明" disabled></b-textarea>
                      <b-form-invalid-feedback v-if="
                        i.content.contents.contents[i.content.tabIndex].body
                          .contents.length > 1
                      " :state="!v$.$dirty || !messagesValidation?.[idx]?.[i.content.tabIndex]?.errorBodyDescription">
                        此欄位為必填
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div v-for="(a, adx) in i.content.contents.contents[
                    i.content.tabIndex
                  ].footer.contents.filter((x) => {
                    return x.type == 'button';
                  })" :key="adx">
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label text-right">
                        動作{{ adx + 1 }}
                      </label>
                      <div class="col-sm-9">
                        <b-input :disabled="isView" class="form-control" placeholder="輸入動作標籤的說明" maxlength="15" required
                          v-model.trim="a.action.label" />
                        <b-form-invalid-feedback
                          :state="!v$.$dirty || !messagesValidation?.[idx]?.[i.content.tabIndex]?.footer?.[adx]?.errorLabel">
                          此欄位為必填 </b-form-invalid-feedback>
                      </div>
                      <div class="col-sm-1">
                        <b-button :disabled="isView" variant="outline-dark" size="lg" class="px-3" @click="
                          () => {
                            i.content.contents.contents[
                              i.content.tabIndex
                            ].footer.contents.splice(adx, 1);
                          }
                        "><i class="fa fa-times m-0" aria-hidden="true"></i></b-button>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label text-right">
                        類型
                      </label>
                      <div class="col-sm-9">
                        <b-select :disabled="isView">
                          <b-select-option>網址</b-select-option>
                        </b-select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="offset-sm-2 col-sm-9">
                        <b-input :disabled="isView" class="form-control" type="url" placeholder="輸入網址" required
                          v-model.trim="a.action.uri" />
                        <b-form-invalid-feedback
                          :state="!v$.$dirty || !messagesValidation?.[idx]?.[i.content.tabIndex]?.footer?.[adx]?.errorUri">
                          請填入正確連結 </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="offset-sm-2 col-sm-10">
                      <b-button :disabled="isView" variant="primary" @click="
                        () => {
                          i.content.contents.contents[
                            i.content.tabIndex
                          ].footer.contents.push({
                            style: 'link',
                            type: 'button',
                            height: 'sm',
                            action: {
                              type: 'uri',
                              label: '',
                              uri: '',
                            },
                            color: '#5B82DB',
                          });
                        }
                      ">新增動作</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-card>
        <div class="d-flex">
          <b-tooltip v-if="messages.length >= 5" target="btn-add-message" placement="top">
            LINE 限制最多五則訊息
          </b-tooltip>
          <div id="btn-add-message">
            <b-button v-if="!isView" variant="inverse-primary" :disabled="messages.length >= 5" @click="addMessage">
              <span class="mdi mdi-message-plus"></span>
              新增訊息
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="isTemplatePage" class="d-flex">
        <div class="flex-fill d-flex justify-content-center">
          <b-button v-if="!isView" @click="submit" variant="success" :disabled="!isTemplateCopy">
            <span>儲存</span>
          </b-button>
          <b-button variant="inverse-danger" v-else @click="handleCancel">返回</b-button>
        </div>
      </div>
      <div v-else class="d-flex">
        <div class="flex-fill d-flex justify-content-center">
          <b-button class="mr-2" @click="save" variant="success" :disabled="isView">
            <span>儲存草稿</span>
          </b-button>
          <b-button class="mr-2" @click="saveAndSubmit" variant="success" :disabled="isView">
            <span>預約推播</span>
          </b-button>
          <b-button @click="submitNow" variant="success" :disabled="isView">
            <span>立即推播</span>
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import pushMessageTemplateApi from "../../../apis/push-message-template";
import pushMessageApi from "../../../apis/push-message";
import audienceApi from "../../../apis/audience";
import { mapState, mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vue2-timepicker";
import checkPermission from "@/mixins/checkPermission";
import _ from "lodash";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { PUSH_MESSAGE_STATUS } from "@/consts";
import StaffAddCustomer from "@/pages/Dashboard/Staff/StaffAddCustomer.vue";
import ImageSelector from "@/components/ImageSelector";
import imageApi from "@/apis/image";
import PermissionChecker from "@/utils/PermissionChecker";
import { format, isBefore, subMinutes, set } from "date-fns";
import Vue from "vue";

const imagemapTemplate = [
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 1040,
          height: 1040,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 520,
          height: 1040,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 520,
          y: 0,
          width: 520,
          height: 1040,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 1040,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 520,
          width: 1040,
          height: 520,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 1040,
          height: 346.666,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 346.666,
          width: 1040,
          height: 346.666,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 693.333,
          width: 1040,
          height: 346.666,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 520,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 520,
          y: 0,
          width: 520,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 520,
          width: 520,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 520,
          y: 520,
          width: 520,
          height: 520,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 1040,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 520,
          width: 520,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 520,
          y: 520,
          width: 520,
          height: 520,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 1040,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 520,
          width: 1040,
          height: 260,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 780,
          width: 1040,
          height: 260,
        },
      },
    ],
  },
  {
    type: "imagemap",
    baseUrl: "",
    altText: "",
    baseSize: {
      height: 1040,
      width: 1040,
    },
    actions: [
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 0,
          width: 346.666,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 346.666,
          y: 0,
          width: 346.666,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 693.333,
          y: 0,
          width: 346.666,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 0,
          y: 520,
          width: 346.666,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 346.666,
          y: 520,
          width: 346.666,
          height: 520,
        },
      },
      {
        type: "uri",
        linkUri: "",
        label: "",
        area: {
          x: 693.333,
          y: 520,
          width: 346.666,
          height: 520,
        },
      },
    ],
  },
];

const textTemplate = {
  type: "text",
  text: "",
};

const imageTemplate = {
  type: "image",
  originalContentUrl: null,
  previewImageUrl: null,
};

const flexHeroTemplate = [
  {
    type: "box",
    layout: "vertical",
    contents: [
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            type: "image",
            url: "",
            size: "full",
            aspectRatio: "1:1",
            aspectMode: "cover",
          },
        ],
      },
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            type: "text",
            text: "宣傳標語",
            color: "#ffffff",
            align: "center",
            size: "xs",
            offsetTop: "4px",
          },
        ],
        position: "absolute",
        cornerRadius: "15px",
        backgroundColor: "#ff334b",
        height: "25px",
        offsetTop: "10px",
        offsetStart: "10px",
        paddingStart: "5px",
        paddingEnd: "5px",
      },
    ],
    paddingAll: "0px",
  },
  {
    type: "box",
    layout: "vertical",
    contents: [
      {
        type: "box",
        layout: "horizontal",
        contents: [
          {
            type: "image",
            url: "",
            flex: 1,
            size: "full",
            aspectMode: "cover",
            aspectRatio: "1:2",
          },
          {
            type: "image",
            url: "",
            flex: 1,
            size: "full",
            aspectMode: "cover",
            aspectRatio: "1:2",
          },
        ],
        paddingAll: "0px",
        alignItems: "center",
      },
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            type: "text",
            text: "宣傳標語",
            color: "#ffffff",
            align: "center",
            size: "xs",
            offsetTop: "4px",
          },
        ],
        position: "absolute",
        cornerRadius: "15px",
        backgroundColor: "#ff334b",
        height: "25px",
        offsetTop: "10px",
        offsetStart: "10px",
        paddingStart: "5px",
        paddingEnd: "5px",
      },
    ],
    paddingAll: "0px",
  },
  {
    type: "box",
    layout: "horizontal",
    contents: [
      {
        type: "box",
        layout: "horizontal",
        contents: [
          {
            type: "image",
            url: "",
            flex: 1,
            aspectMode: "cover",
            size: "full",
            aspectRatio: "1:2",
          },
        ],
        flex: 1,
        height: "100%",
        alignItems: "center",
      },
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            type: "image",
            url: "",
            size: "full",
            flex: 1,
            aspectMode: "cover",
            aspectRatio: "1:1",
          },
          {
            type: "image",
            url: "",
            size: "full",
            flex: 1,
            aspectMode: "cover",
            aspectRatio: "1:1",
          },
        ],
        flex: 1,
      },
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            type: "text",
            text: "宣傳標語",
            color: "#ffffff",
            align: "center",
            size: "xs",
            offsetTop: "4px",
          },
        ],
        position: "absolute",
        cornerRadius: "15px",
        backgroundColor: "#ff334b",
        height: "25px",
        offsetTop: "10px",
        offsetStart: "10px",
        paddingStart: "5px",
        paddingEnd: "5px",
      },
    ],
    paddingAll: "0px",
    alignItems: "center",
  },
];

const flexTemplate = {
  type: "bubble",
  hero: null,
  body: {
    type: "box",
    layout: "vertical",
    contents: [
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            size: "lg",
            weight: "bold",
            type: "text",
            text: "",
            align: "start",
            color: "#DE006F",
            wrap: true,
          },
        ],
      },
      {
        type: "box",
        layout: "vertical",
        contents: [
          {
            type: "text",
            text: "",
            size: "md",
            wrap: true,
          },
        ],
      },
    ],
    paddingAll: "10px",
    paddingTop: "10px",
    paddingBottom: "0px",
    paddingStart: "15px",
  },
  footer: {
    spacing: "sm",
    flex: 0,
    type: "box",
    contents: [
      {
        style: "link",
        type: "button",
        height: "sm",
        action: {
          type: "uri",
          label: "",
          uri: "",
        },
        color: "#5B82DB",
      },
      {
        style: "link",
        type: "button",
        height: "sm",
        action: {
          type: "uri",
          label: "",
          uri: "",
        },
        color: "#5B82DB",
      },
      {
        type: "spacer",
        size: "sm",
      },
    ],
    layout: "vertical",
  },
  styles: {
    hero: {
      backgroundColor: "#FFFFFF",
    },
  },
};

// const condition = (message) => {
//   if (message.content.type == "text") {
//     return { text: { required } };
//   }
// };

// let localRules = {
//   title: { required },
//   publish_at: {
//     date: { required },
//     time: { HH: { required }, mm: { required } },
//   },
// };

// let textRule = {
//   content: {
//     text: { required },
//   },
// };

function url(urlString) {
  if (typeof urlString !== 'string' || urlString.trim() === '') {
    return false
  }

  try {
    new URL(urlString)
    return true
  } catch {
    return false
  }
}

export default {
  setup: () => ({ v$: useVuelidate() }),
  mixins: [checkPermission],
  components: { Datepicker, VueTimepicker, StaffAddCustomer, ImageSelector },
  validations() {
    //let textRule = {};

    const localRules = {
      title: { required },
    };

    if (!this.isTemplatePage) {
      localRules.publish_at = {
        date: { required },
        time: { HH: { required }, mm: { required } },
        equalOrLargerNow() {
          const publishAt = set(new Date(this.publish_at.date), {
            hours: this.publish_at.time.HH,
            minutes: this.publish_at.time.mm,
          })

          let threshold = new Date();
          threshold.setSeconds(0);
          threshold.setMilliseconds(0);
          threshold = subMinutes(threshold, 1)

          return isBefore(threshold, publishAt);
        },
      };
      localRules.audienceId = { required };
    }

    return localRules;
  },
  data() {
    return {
      title: "",
      zh,
      publish_at: {
        date: null,
        time: { HH: null, mm: null },
      },
      pushType: this.$route.params.messageID === "create" ? 'multicast' : null,
      audiences: [{ value: null, text: '請選擇受眾群組' }],
      audienceId: null,
      branchId: null,
      status: PUSH_MESSAGE_STATUS.DRAFT,
      pushTypeOptions: [
        { text: '群組推播', value: 'multicast' },
        { text: '分眾廣播', value: 'narrowcast' },
      ],
      messageTypeOptions: [
        { text: "文字", value: "text", template: _.cloneDeep(textTemplate) },
        { text: "圖片", value: "image", template: _.cloneDeep(imageTemplate) },
        {
          text: "圖文訊息",
          value: "imagemap",
          template: _.cloneDeep(imagemapTemplate[0]),
        },
        {
          text: "多頁訊息",
          value: "flex",
          template: {
            type: "flex",
            tabIndex: 0,
            altText: null,
            contents: {
              type: "carousel",
              contents: [_.cloneDeep(flexTemplate)],
            },
          },
        },
      ],
      messages: [],
      messagesValidation: [],
      imagemapTemplate: _.cloneDeep(imagemapTemplate),
      flexHeroTemplate: _.cloneDeep(flexHeroTemplate),
      isFetchingAudiences: false,
    };
  },
  watch: {
    title(title) {
      (this.messages ?? [])?.map(message => {
        if (['flex', 'imagemap'].includes(message?.content?.type)) {
          message.content.altText = title
        }
        return message
      })
    },
    messages: {
      handler(messages) {
        this.updateMessagesValidator()
        return (messages ?? [])?.map(message => {
          if (['flex', 'imagemap'].includes(message?.content?.type)) {
            message.content.altText = this.title
          }
          return message
        })
      },
      deep: true,
    }
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters('general', [
      'myBranches',
    ]),
    ...mapGetters("route", ["routeQuery"]),
    isCreate() {
      return this.$route.params.messageID === "create";
    },
    isTemplatePage() {
      return this.$route.path.includes('push-message-template')
    },
    isView() {
      if (this.isTemplatePage) {
        return this.$route.name === 'PushMessageTemplateDetail' && this.$route.params.messageID !== 'create';
      } else {
        return this.$route.name === 'PushMessageDetail' && this.$route.params.messageID !== 'create';
      }

    },
    isEditing() {
      if (this.isTemplatePage) {
        return this.$route.name === 'PushMessageTemplateDetailEdit';
      } else {
        return this.$route.name === 'PushMessageDetailEdit';
      }
    },
    isDetailCopy() {
      return this.$route.name === 'PushMessageDetailCopy';
    },
    isTemplateCopy() {
      return this.$route.name === 'PushMessageTemplateCopy';
    },
    branchSelectIsDisabled() {
      return this.isView || !this.checkPermission([this.consts.OA_PUSH_VIEW_BRANCH]) || this.isFetchingAudiences
    },
    canBroadcastToWholeOrganization() {
      return this.checkPermission([this.consts.OA_PUSH_VIEW_NO_BRANCH])
    },
    firstBranchOption() {
      return this.canBroadcastToWholeOrganization ? { value: null, text: '品牌組織階層(無隸屬分店)' } : { value: 'invalid', text: '請選擇分店' }
    },
    branchOptions() {
      let options = this.myBranches
        .map(branch => {
          let branchName = `${branch.branch_code} ${branch.name}`
          return {
            value: branch.id,
            text: branchName
          }
        })
      options = [
        this.firstBranchOption,
        ...options
      ]

      if (this.messages.branch_id && !options.find((o) => o.value === this.messages.branch_id)) {
        options.push({
          value: this.messages.branch_id,
          text: _.get(this.messages, 'branch.name')
        })
      }
      return options
    },
    saveable: {
      cache: false,
      get() {
        return !this.isTemplatePage && this.branchId !== 'invalid'
      }
    },
  },
  async mounted() {
    if (this.isTemplatePage) {
      if (this.isEditing || this.isView || this.isTemplateCopy) {
        await this.fetchTemplateMessage();
      }
      else {
        this.messages = [{ content: _.cloneDeep(textTemplate), order: 0 }];
      }
    } else {
      // 列表頁因為 query 不能帶 null，所以用 no-branch 來表示沒有分店
      this.branchId = this.$route.query.branch_id === 'no-branch'
        ? null
        : this.$route.query.branch_id || (this.canBroadcastToWholeOrganization ? null : 'invalid')
      this.audienceId = this.$route.query.audience_id || null;

      if (this.isEditing || this.isView || this.isDetailCopy) {
        await this.fetchMessage();
      }
      else if (this.$route.query.templateID) {
        await this.fetchTemplateMessage();
      }
      else {
        this.messages = [{ content: _.cloneDeep(textTemplate), order: 0 }];
      }
      await this.fetchAudiences();
    }
  },

  methods: {
    appendAltTextOnFlexMessage(messages) {
      return (messages ?? [])?.map(message => {
        if (['flex', 'imagemap'].includes(message?.content?.type)) {
          message.content.altText = this.title
        }
        return message
      })
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker;
      return checker.check(permissions);
    },
    async testBroadcast(customer) {
      const isValid = await this.validate()
      if (!isValid) return

      if (!this.title) {
        this.$swal("請填入推播標題", "", "danger");
        return
      }
      const payload = {
        details: this.appendAltTextOnFlexMessage(this.messages),
        customer: customer
      };
      this.$swal({
        text: `確定發送推播給 ${customer.name} 嗎？`,
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: "確定推播",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            await pushMessageApi.broadcastPushMessage(
              payload
            );

            this.$swal("推播成功", "", "success");
          } catch (e) {
            console.error(e);
            this.$swal("推播失敗", "", "danger");
          }
        }
      })
    },
    async fetchAudiences() {
      let page = 1, last_page = 1
      this.audiences = [{ value: null, text: '請選擇受眾群組' }]
      this.isFetchingAudiences = true

      try {
        while (page <= last_page) {
          const params = { per_page: 100, page }
          if (!['invalid'].includes(this.branchId)) {
            params.branch_id = this.branchId
          }
          let { data } = await audienceApi.getAudiences(params)
          last_page = data.meta.last_page

          this.audiences = this.audiences.concat(data.data.map(d => ({ value: d.id, text: d.title })))
          ++page
        }
      } catch (e) {
        this.$swal("獲取受眾失敗", "", "error");
      }

      this.isFetchingAudiences = false
    },
    async fetchTemplateMessage() {
      this.isFetch = true;

      try {
        const messageID = this.isCreate ? this.$route.query.templateID : this.$route.params.messageID
        const { data } = await pushMessageTemplateApi.getPushMessageTemplate(
          messageID
        );

        this.messages = data.data.details;
        this.title = data.data.title + (this.isTemplateCopy ? '(複製)' : '');
        this.status = data.data.status;

      } catch (error) {
        console.log("error", error);
      }
      this.isFetch = false;
    },
    async fetchMessage() {
      this.isFetch = true;

      try {
        const messageID = this.isCreate ? this.$route.query.templateID : this.$route.params.messageID
        const { data } = await pushMessageApi.getPushMessage(
          messageID
        );

        this.messages = data.data.details;
        this.title = data.data.title + (this.isDetailCopy ? '(複製)' : '');
        this.status = data.data.status;

        const newDate = new Date(data.data.publish_at);
        this.publish_at.date = newDate;
        this.publish_at.time.HH = format(newDate, "HH");
        this.publish_at.time.mm = format(newDate, "mm");
        this.audienceId = data.data.audience_id || null;
        this.branchId = data.data.branch_id || (this.canBroadcastToWholeOrganization ? null : 'invalid');
        this.pushType = data.data.push_type;
      } catch (error) {
        console.log("error", error);
      }
      this.isFetch = false;
    },
    messageTypeChange: function (i, idx) {
      var template = _.cloneDeep(
        this.messageTypeOptions.find((x) => {
          return x.value == i.content.type;
        }).template
      );

      if (template.type == "flex") {
        template.contents.contents[0].hero = _.cloneDeep(flexHeroTemplate[0]);
      }

      this.messages.splice(idx, 1, { content: template, order: null });
      this.$forceUpdate();
    },

    addMessage: function () {
      this.messages.push({
        content: _.cloneDeep(textTemplate),
        order: this.messages.length,
      });
    },

    swapMessage: function (idx, order) {
      const tmp = _.cloneDeep(this.messages[idx]);
      Vue.set(this.messages, idx, this.messages[idx + order]);
      Vue.set(this.messages, idx + order, tmp);
    },
    removeMessage: function (idx) {
      this.messages.splice(idx, 1);
    },
    flexNewPage: function (i) {
      let template = _.cloneDeep(flexTemplate);
      template.hero = _.cloneDeep(flexHeroTemplate[0]);

      i.content.contents.contents.push(template);
    },
    flexImageChange: function (message, value) {
      message.content.contents.contents[message.content.tabIndex].hero =
        _.cloneDeep(flexHeroTemplate[value - 1]);
    },
    async uploadImage(image, target) {
      const url = await this.uploadByBase64(image);
      target.originalContentUrl = url;
      target.previewImageUrl = url;
    },
    setFlexTabIndex(idx, cdx) {
      const message = this.messages[idx]
      if (cdx < 0 || cdx > message.content.contents.contents.length - 1) {
        return;
      }
      message.content.tabIndex = cdx;
    },
    deleteFlexTab(idx, cdx) {
      const message = this.messages[idx];
      const tabIndex = message.content.tabIndex;
      if (tabIndex === cdx && cdx !== 0) {
        this.setFlexTabIndex(idx, cdx - 1);
      }
      Vue.delete(message.content.contents.contents, cdx);
    },
    async uploadImageMap(image, target) {
      const url = await this.uploadByBase64(image);
      target.url = url
      target.baseUrl = url;
      // 因為 line 要求 baseUrl 要支援可以加上 /240 /360 等路徑支援不同大小
      // eg. image.com/avatar.jpg/240 或者 image.com/avatar.jpg/360
      // 目前 google 戴上 ?/240 可以維持顯示原圖片，暫時以加上 ? 做處理
      target.baseUrl += '?'
    },

    async uploadFlex(image, target) {
      const url = await this.uploadByBase64(image);
      target.url = url
    },

    async uploadByBase64(image) {
      try {
        let response = await imageApi.uploadByBase64(image);
        return response.data.data.image.url;
      } catch (error) {
        this.$swal.fire({
          title: `上傳圖片失敗：${error.response.data.message}`,
          type: "error",
        });
      }
    },
    async saveAndSubmit() {
      this.status = PUSH_MESSAGE_STATUS.RESERVE
      this.save()
    },
    async submitNow() {
      this.status = PUSH_MESSAGE_STATUS.RESERVE
      let newDate = new Date()
      this.publish_at.date = newDate
      this.publish_at.time.HH = format(newDate, "HH")
      this.publish_at.time.mm = format(newDate, "mm")
      this.save()
    },
    async save() {
      const isValid = await this.validate()
      if (!isValid) return

      const newDate = this.publish_at.date;
      newDate.setHours(this.publish_at.time.HH);
      newDate.setMinutes(this.publish_at.time.mm);

      this.messages.forEach((m, idx) => {
        m.order = idx;
      });

      const payload = {
        title: this.title,
        status: this.status,
        publish_at: `${format(newDate, "yyyy-MM-dd")}T${format(
          newDate,
          "HH:mm:ss"
        )}`,
        details: this.appendAltTextOnFlexMessage(this.messages),
        audience_id: this.audienceId,
        branch_id: this.branchId,
        push_type: this.pushType,
      };

      try {
        this.isLoading = true;
        if (this.isEditing) {
          payload.id = this.$route.params.messageID;
          const messageID = this.isCreate ? this.$route.query.templateID : this.$route.params.messageID
          await pushMessageApi.updatePushMessage(
            messageID,
            payload
          );

          this.$swal("修改成功", "", "success");

          // Todo這裡的routeQuery會有問題
          this.$router.push({ name: "PushMessage", query: this.routeQuery });
        } else {
          if (this.isDetailCopy) {
            payload.status = PUSH_MESSAGE_STATUS.DRAFT
          }

          await pushMessageApi.createPushMessage(payload);

          let title = this.isDetailCopy ? "複製成功" : "新增成功";
          this.$swal(title, "", "success");

          // Todo這裡的routeQuery會有問題
          this.$router.push({ name: "PushMessage", query: this.routeQuery });
        }
      } catch (error) {
        let errorMessage = error.response.data.message

        if (
          error.response &&
          error.response.status === 422 &&
          error.response.data.message
        ) {
          errorMessage = Object.values(errorMessage).flat().join("\n");
        }

        this.$swal.fire({
          title: "錯誤",
          type: "error",
          text: errorMessage,
        });
      }
      this.isLoading = false;
    },
    async submit() {
      const isValid = await this.validate()
      if (!isValid) return

      this.messages.forEach((m, idx) => {
        m.order = idx;
      });

      const payload = {
        title: this.title,
        status: 0,
        details: this.appendAltTextOnFlexMessage(this.messages),
      };

      try {
        this.isLoading = true;
        if (this.isEditing) {
          payload.id = this.$route.params.messageID;
          const messageID = this.isCreate ? this.$route.query.templateID : this.$route.params.messageID
          await pushMessageTemplateApi.updatePushMessageTemplate(
            messageID,
            payload
          );

          this.$swal("修改成功", "", "success");

          this.$router.push({ name: "PushMessageTemplate", query: this.routeQuery });
        } else {
          if (this.isTemplateCopy) {
            payload.status = PUSH_MESSAGE_STATUS.DRAFT
          }
          await pushMessageTemplateApi.createPushMessageTemplate(payload);

          let title = this.isTemplateCopy ? "複製成功" : "新增成功";
          this.$swal(title, "", "success");

          this.$router.push({ name: "PushMessageTemplate", query: this.routeQuery });
        }
      } catch (error) {
        let errorMessage = error.response.data.message

        if (
          error.response &&
          error.response.status === 422 &&
          error.response.data.message
        ) {
          errorMessage = Object.values(errorMessage).flat().join("\n");
        }

        this.$swal.fire({
          title: "錯誤",
          type: "error",
          text: errorMessage,
        });
      }
      this.isLoading = false;
    },

    handleCancel() {
      this.$router.push({ name: "PushMessageTemplate", query: this.routeQuery });
    },

    async handleBranchIsSelected() {
      await this.fetchAudiences();
    },
    setImageMapTemplate(t, idx) {
      t.url = this.messages?.[idx]?.content?.baseUrl;
      t.baseUrl = this.messages?.[idx]?.content?.baseUrl;
      Vue.set(this.messages, idx, { content: t, order: null });
      this.$bvModal.hide('modal-imagemap-template');
      this.$forceUpdate();
    },
    async validate() {
      const [result, isMessagesValid] = [await this.v$.$validate(), this.validateMessages()];
      if (!result || !isMessagesValid) {
        this.$swal.fire({
          title: "錯誤",
          type: "error",
          text: "請確認所有訊息內容皆已填寫完整",
        });
        return false
      }
      return true
    },
    validateMessages() {
      return (this.messages ?? [])?.reduce((acc, message, i) => {
        const messageValidation = this.messagesValidation?.[i];
        if (message.content.type === 'text') {
          return acc && !messageValidation.error
        } else if (message.content.type === 'image') {
          return acc && !messageValidation.error
        } else if (message.content.type === 'imagemap') {
          let isValid = !messageValidation.error
          messageValidation.actions?.forEach((actionValidation) => {
            isValid = isValid && !actionValidation.errorLinkUri && !actionValidation.errorLabel
          })
          return acc && isValid
        } else if (message.content.type === 'flex') {
          let isValid = true
          messageValidation?.forEach((mValidation) => {
            isValid = isValid
              && !mValidation.errorHeroText
              && !mValidation.errorBodyText
              && !mValidation.errorBodyDescription
              && !mValidation.errorImageUrl
            mValidation.footer?.forEach((fValidation) => {
              isValid = isValid && !fValidation.errorLabel && !fValidation.errorUri
            })
          })
          return acc && isValid
        }
        return acc
      }, true)
    },
    updateMessagesValidator() {
      this.messagesValidation = (this.messages ?? [])?.map((message) => {
        if (message.content.type === 'text') {
          const validate = () => !message.content.text
          return {
            text: message.content.text,
            validate,
            error: validate()
          }
        } else if (message.content.type === 'image') {
          const validate = () => !message.content.originalContentUrl
          return {
            originalContentUrl: message.content.originalContentUrl,
            validate,
            error: validate()
          }
        } else if (message.content.type === 'imagemap') {
          const validate = () => !message?.content?.baseUrl
          return {
            baseUrl: message?.content?.baseUrl,
            validate,
            error: validate(),
            actions: message?.content?.actions?.map((action) => {
              const validateLinkUri = () => !action.linkUri || !url(action.linkUri)
              const validateLabel = () => !action.label
              return {
                linkUri: action.linkUri,
                validateLinkUri,
                errorLinkUri: validateLinkUri(),
                label: action.label,
                validateLabel,
                errorLabel: validateLabel()
              }
            })
          }
        } else if (message.content.type === 'flex') {
          const contents = message?.content?.contents
          return (contents.contents ?? []).map((m) => {
            const validateHeroText = () => !m.hero.contents[1]?.contents[0]?.text
            const validateBodyText = () => !m.body.contents[0]?.contents[0]?.text
            const validateBodyDescription = () => !m.body.contents[m.body.contents.length - 1]?.contents[0]?.text
            const validateImageUrl = () => m.hero.contents[0].contents.find(x => x.url == '')
            return {
              heroText: m.hero.contents[1]?.contents[0]?.text,
              validateHeroText,
              errorHeroText: validateHeroText(),
              bodyText: m.body.contents[0]?.contents[0]?.text,
              validateBodyText,
              errorBodyText: validateBodyText(),
              validateBodyDescription,
              errorBodyDescription: validateBodyDescription(),
              imageUrl: m.hero.contents[0].contents,
              validateImageUrl,
              errorImageUrl: validateImageUrl(),
              footer: m.footer.contents.filter((x) => x.type == 'button').map((f) => {
                const validateLabel = () => !f.action.label
                const validateUri = () => !f.action.uri || !url(f.action.uri)
                return {
                  label: f.action.label,
                  validateLabel,
                  errorLabel: validateLabel(),
                  uri: f.action.uri,
                  validateUri,
                  errorUri: validateUri()
                }
              })
            }
          })
        }
      })
    },
  },
};
</script>

<style lang="scss">
.modal-backdrop {
  opacity: 0.5;
}

.message-image {
  .image {
    max-width: 200px;
    position: relative;
    display: inline-block;

    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 30px;
      height: 30px;
      padding: 0;
    }
  }
}

.uploader {
  height: 300px;

  .custom-file-input {
    height: 100%;
  }

  .custom-file-label {
    height: 100%;
    width: 100%;

    &::after {
      content: none !important;
    }

    .dropzone {
      height: 300px;
    }
  }
}

.message-imagemap {
  .image {
    width: 220px;

    .template {
      position: relative;
      border-width: 2px !important;
      min-height: 216px;

      .action {
        position: absolute;
        border-width: 2px !important;
        font-size: 18pt;
        text-align: center;
        color: white;
        font-weight: bold;
        background: rgba($color: #666, $alpha: 0.3);

        span {
          display: inline-block;
          vertical-align: middle;
          line-height: normal;
        }
      }
    }
  }
}

#modal-imagemap-template {
  .template {
    width: 10vw;
    height: 10vw;
    border-width: 2px !important;
    position: relative;

    .action {
      position: absolute;
      border-width: 2px !important;
    }
  }
}

.message-flex {
  .image {
    width: 320px;

    .image-frame {
      height: 286px;
      position: relative;
      background-color: #ddd;

      img {
        width: 100%;
        height: 100%;
        // border: solid 1px #ddd;

        object-fit: cover;
      }

      .frame {
        text-shadow: 0 0 15px rgba(0, 0, 0, 0.8);
        background-color: #ddd;
        border: solid 1px white;

        &::after {
          position: absolute;
          top: 50%;
          left: 50%;
          font-size: 18pt;
          color: white;
          font-weight: bold;
          transform: translate(-50%, -50%);
        }
      }

      .frame-1 {
        .frame {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;

          &::after {
            content: "A";
          }
        }
      }

      .frame-2 {
        .frame:first-child {
          position: absolute;
          top: 0;
          right: 50%;
          left: 0;
          bottom: 0;
          width: 50%;
          height: 100%;

          &::after {
            content: "A";
          }
        }

        .frame:nth-child(2) {
          position: absolute;
          top: 0;
          right: 0;
          left: 50%;
          bottom: 0%;
          width: 50%;
          height: 100%;

          &::after {
            content: "B";
          }
        }
      }

      .frame-3 {
        .frame:first-child {
          position: absolute;
          top: 0;
          right: 50%;
          left: 0;
          bottom: 0;
          width: 50%;
          height: 100%;

          &::after {
            content: "A";
          }
        }

        .frame:nth-child(2) {
          position: absolute;
          top: 0;
          right: 0;
          left: 50%;
          bottom: 50%;
          width: 50%;
          height: 50%;

          &::after {
            content: "B";
          }
        }

        .frame:nth-child(3) {
          position: absolute;
          top: 50%;
          right: 0;
          left: 50%;
          bottom: 0;
          width: 50%;
          height: 50%;

          &::after {
            content: "C";
          }
        }
      }
    }
  }

  .carousel-control-next,
  .carousel-control-prev {
    top: 50%;
    bottom: 50%;
    background-color: #666;
    height: 35px;
    width: 35px;
    border-radius: 100%;
  }

  .flex-button {
    overflow: hidden;
    border-radius: 1rem !important;

    .altText {
      position: absolute;
      top: 1rem;
      left: 1rem;
      z-index: 1;
    }

    .body {
      .lg {
        font-size: 1.375rem;
      }

      .md {
        font-size: 1rem;
      }

      .sm {
        font-size: 0.875rem;
      }
    }

    .footer {
      background-color: transparent;
      border: none;

      .btn {
        font-size: 1rem;
      }
    }
  }

  .image-button {
    width: 100px;
    height: 100px;
    overflow: hidden;
  }

  .remove {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.spinner-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.5);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .is-invalid.is-invalid {
  border-color: #dc3545;
}
</style>
